
<div class="container mt-5">
    <div id="prueba"><h1>Agregar Ciudad de {{ciudad.nombre}}</h1></div>
    <form (ngSubmit)="!todoForm.invalid && saveCiudad()" #todoForm="ngForm">
        <fieldset class="form-group">
            <label for="id">ID</label>
            <input type="text" class= "form-control"name ="id" required="required"  [(ngModel)]="ciudad.id">
        </fieldset>    
        <fieldset class="form-group">
            <label for="nombre">Nombre</label>
            <input type="text" class= "form-control"name ="nombre" required="required"  [(ngModel)]="ciudad.nombre">
        </fieldset>

        <fieldset class="form-group">
            <label for="nombre">Temperatura</label>
            <input type="text" class= "form-control"name ="temperatura" required="required"  [(ngModel)]="ciudad.temperatura">
        </fieldset>
        <div class="botonCrear">
            <button class="btn btn-success" type="submit">Guardar</button>
        </div>
    </form> 
</div>